import $ from "jquery";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        const hash = window.location.hash;

        if (window.location.pathname.includes('/profile') && hash === '#priorities') {
            this.showTabAndScroll(hash);
        }
    }

    scroll(event) {
        event.preventDefault();

        const href = event.currentTarget.getAttribute('href');
        const hash = href && href !== '#' ? href : '#priorities';

        if (!window.location.pathname.includes('/profile')) {
            window.location.href = `/profile${hash}`;
        } else {
            this.showTabAndScroll(hash);
        }
    }

    showTabAndScroll(hash) {
        const $tabLink = $(`a[href='${hash}-tab']`);
        if ($tabLink.length) {
            $tabLink.tab('show');
        }

        const $target = $(`${hash}-tab`);
        if ($target.length) {
            const height = $target.offset().top - 100;
            $("html, body").animate({
                scrollTop: height
            }, 500);
        }
    }
}
